import DevicesIcon from '@mui/icons-material/Devices';
import { Theme, useMediaQuery } from '@mui/material';
import { ReactElement } from 'react';
import {
  BooleanField,
  BulkDeleteWithConfirmButton,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  SearchInput,
  SimpleList,
  TextField,
} from 'react-admin';

import UserDeviceTokenEditEmbedded from './UserDeviceTokenEditEmbedded';

export const UserDeviceTokenIcon = DevicesIcon;

const getDeviceTokenFilters = (): ReactElement[] => {
  const filters = [<SearchInput source="user_id,device_id,fcm_token" alwaysOn />];
  return filters.filter((filter) => filter !== null) as ReactElement[];
};

const UserDeviceTokenBulkActionButtons = (props: any) => <BulkDeleteWithConfirmButton {...props} />;

export const UserDeviceTokenList = () => {
  return (
    <List filters={getDeviceTokenFilters()} sort={{ field: 'created_at', order: 'DESC' }}>
      {useMediaQuery((theme: Theme) => theme.breakpoints.down('md')) ? (
        <SimpleList
          primaryText={(record) => `${record.user_id} - ${record.device_id}`}
          secondaryText={(record) => (record.fcm_token ? record.fcm_token.substring(0, 20) + '...' : '')}
          tertiaryText={(record) => new Date(record.created_at).toLocaleString()}
        />
      ) : (
        <Datagrid
          expand={<UserDeviceTokenEditEmbedded />}
          rowClick="expand"
          optimized
          bulkActionButtons={<UserDeviceTokenBulkActionButtons />}
        >
          <TextField source="id" />
          <ReferenceField source="user_id" reference="user">
            <TextField source="display_name" />
          </ReferenceField>
          <TextField source="device_id" />
          <TextField
            source="fcm_token"
            label="Token"
            sortable={false}
            render={(record: any) => (record.fcm_token ? record.fcm_token.substring(0, 30) + '...' : '')}
          />
          <BooleanField source="is_subscribed" />
          <DateField source="created_at" showTime />
          <DateField source="updated_at" showTime />
        </Datagrid>
      )}
    </List>
  );
};
